// Farsi (Persian) translations
export const fa = {
  // Common
  common: {
    home: 'خانه',
    settings: 'تنظیمات',
    language: 'زبان',
    loading: 'در حال بارگذاری...',
    save: 'ذخیره',
    cancel: 'لغو',
    confirm: 'تایید',
    close: 'بستن',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'تنظیمات',
    home: 'خانه',
    howToPlay: 'نحوه بازی',
    pieceRules: 'قوانین مهره‌ها',
    language: 'زبان',
    manageSubscription: 'مدیریت اشتراک',
    gameHistory: 'تاریخچه بازی',
    analytics: 'تجزیه و تحلیل',
    premiumAccount: 'حساب ویژه',
    chatEnabled: 'چت: فعال',
    chatDisabled: 'چت: غیرفعال',
  },

  // Piece Rules
  pieceRules: {
    title: 'قوانین مهره‌ها',
    description: 'حرکت مهره‌ها را یاد بگیرید',
    selectPiece: 'انتخاب مهره',
    selectedLabel: 'انتخاب شده:',
    statusLabel: 'وضعیت:',
    statusReady: 'آماده',
    statusViewing: 'در حال مشاهده',
    movement: 'حرکت',
    regularMovement: 'حرکت عادی',
    ability: 'توانایی',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'حرکت',
    savage: 'وحشی',
    birdtype: 'نوع پرنده',
    birdType: 'نوع پرنده',
    wallBlock: 'مسدود کردن دیوار',
    moveblocks: 'مسدودسازی حرکت',
    wallclimb: 'بالا رفتن از دیوار',
    lilypad: 'نیلوفر آبی',
    poisonous: 'سمی',
    meadow: 'چمنزار',
    parasiticfungi: 'قارچ انگلی',
    zombification: 'زامبی شدن',
    fungi: 'قارچ',
    traverse: 'عبور',
    capture: 'گرفتن',
    faint: 'غش کردن',
    leap: 'جهش',
    swing: 'تاب خوردن',
    consume: 'مصرف کردن',
    gamble: 'قمار',
    entangle: 'درهم تنیدن',
    ink: 'مرکب',
    rotate: 'چرخش',
    backstep: 'قدم به عقب',
    trample: 'لگدمال کردن',
    charge: 'یورش',
    lane: 'مسیر',
    snakestrike: 'حمله مار',
    shedskin: 'پوست انداختن',
    house: 'خانه',
    plant: 'نوع گیاه',
    planttype: 'نوع گیاه',
    capturehost: 'تصرف میزبان',
    contagion: 'سرایت',
    lonewolf: 'گرگ تنها',
    hop: 'پرش کوچک',
    decay: 'پوسیدگی',
    slide: 'لغزش',
    block: 'مسدود کردن',
    poison: 'سم',
    infection: 'عفونت',
    howl: 'زوزه',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'خرس می‌تواند یک خانه در هر جهت حرکت کند، مانند شاه در شطرنج',
    bearMovementPost: 'فقط توسط مهره‌های دوست مسدود می‌شود (به جز درخت‌ها، خرس‌ها می‌توانند از درخت‌ها بالا بروند!)',
    bearSavage: 'خرس می‌تواند بر توانایی‌های دفاعی مانند بلوک کرگدن غلبه کند',
    bearSavagePost: 'با استفاده از وحشی‌گری، خرس می‌تواند هر مهره‌ای را از هر جهت بگیرد و کشندگی اضافه کند',

    // Crane
    craneMovement: 'درنا می‌تواند ۱ یا ۲ خانه در هر خط مستقیم حرکت کند',
    craneMovementPost: 'درنا حتی می‌تواند از روی مهره‌های دیگر پرواز کند!',
    craneBirdType: 'مهره‌های نوع پرنده نمی‌توانند مهره‌های بزرگ یا درنده را بگیرند',
    craneBirdTypePost: 'این شامل درخت، کرگدن، خرس و گرگ می‌شود',

    // Frog
    frogMovement: 'قورباغه ۲ خانه به صورت مورب می‌پرد',
    frogMovementPost: 'نمی‌تواند فقط یک خانه بپرد',
    frogWallBlock: 'اگر مسیر عادی ۲ خانه‌ای قورباغه توسط دیوار یا مهره دیگری مسدود شود، نمی‌تواند مهره بگیرد',
    frogWallBlockPost: 'حرکت عادی آن به ۱ خانه مورب کاهش می‌یابد',
    frogWallClimb: 'وقتی قورباغه روی دیوار صفحه است (ستون A یا E)، می‌تواند یک خانه بالا یا پایین برود',
    frogWallClimbPost: 'مگر اینکه توسط مهره دوست یا کرگدن جلوی قورباغه مسدود شود',
    frogLilypad: 'اگر قورباغه هنوز در بازی حرکت نکرده، می‌تواند به هر یک از ۳ ردیف اول بپرد به عنوان یک توانایی دفاعی قدرتمند',
    frogLilypadPost: 'می‌تواند با استفاده از پرش نیلوفر هر مهره عادی را بگیرد، به جز کرگدن در ردیف بالاتر از خودش',
    frogPoisonous: 'وقتی هر حیوانی مهره قورباغه را بگیرد، مسموم می‌شود!',
    frogPoisonousPost: 'مهره مسموم شده نوبت بعدی خود را قبل از بهبودی از دست می‌دهد',

    // Fungi
    fungiMovement: 'قارچ می‌تواند یک خانه در هر جهت حرکت کند',
    fungiMovementPost: 'فقط توسط مهره‌های متحد مسدود می‌شود',
    fungiMeadow: 'قارچ توانایی حرکت مهره درخت دشمن را کاهش می‌دهد',
    fungiMeadowPost: 'مهره درخت دشمن نمی‌تواند در فاصله ۱ خانه از مهره قارچ حرکت کند',
    fungiParasitic: 'قارچ می‌تواند مهره درخت دشمن را بی‌حرکت کند',
    fungiParasiticPost: 'اگر قارچ در فاصله ۱ خانه از درخت دشمن باشد، نمی‌تواند حرکت کند تا زمانی که قارچ دور شود یا گرفته شود',
    fungiZombification: 'قارچ می‌تواند هر مهره حیوان دشمنی را که آن را می‌گیرد زامبی کند و به شما اجازه کنترل مهره دشمن برای یک نوبت می‌دهد',
    fungiZombificationPost: 'مهره زامبی شده همچنین برای آن نوبت به عنوان مهره قارچ در نظر گرفته می‌شود، حتی اگر قارچ شاه شما بود بازی تا پایان آن نوبت تمام نمی‌شود',
    fungiFungi: 'قارچ',
    fungiFungiPost: 'مانند سم، درهم تنیدگی و عفونت ویروسی، اما نه زامبی شدن زیرا می‌تواند دیگران را زامبی کند!',

    // Goat
    goatMovement: 'بز می‌تواند یک خانه در هر جهت حرکت کند',
    goatMovementPost: 'بز آهسته حرکت می‌کند اما توانایی‌های قدرتمندی دارد',
    goatTraverse: 'بز می‌تواند از روی هر مهره متصل دیگری عبور کند تا پتانسیل حرکت عظیمی ایجاد کند',
    goatTraversePost: 'بز نمی‌تواند از روی بزهای غش کرده یا مهره‌های کوچک مانند ویروس عبور کند',
    goatCapture: 'بز نمی‌تواند هیچ درنده‌ای را بگیرد',
    goatCapturePost: 'مانند خرس یا گرگ',
    goatFaint: 'بز می‌تواند غش کند تا از گرفته شدن جلوگیری کند به جز از مهره‌های بزرگ مانند درخت و کرگدن',
    goatFaintPost: 'در حالی که غش کرده، حریفان می‌توانند روی بز غش کرده "بایستند" تا حرکت آن را متوقف کنند',

    // Monkey
    monkeyMovement: 'میمون می‌تواند یک خانه در هر جهت حرکت کند',
    monkeyMovementPost: 'بدون مهره‌های دیگر برای استفاده، میمون حرکت محدودی دارد',
    monkeyLeap: 'میمون، مانند بازی چکرز، می‌تواند از روی مهره‌های دیگر در یک خط مستقیم بپرد برای پتانسیل حرکت عظیم',
    monkeyLeapPost: 'اما اگر از روی مهره دشمن بپرد، میمون باید تاس بزند تا از پرش جان سالم به در ببرد، شانس ۱/۶ گرفته شدن برای هر دشمنی که از روی آن می‌پرد!',
    monkeySwing: 'اگر میمون از روی درخت بپرد، میمون نوبت اضافی می‌گیرد',
    monkeySwingPost: 'استفاده از تاب درخت یک کمبو هم‌افزای قدرتمند بین مهره میمون و درخت ایجاد می‌کند',
    monkeyConsume: 'میمون می‌تواند یک قارچ را برای نوبت اضافی مصرف کند',
    monkeyConsumePost: 'که منجر به ترکیبات ویرانگر در ترکیب با نوبت‌های اضافی دیگر می‌شود',
    monkeyGamble: 'علاوه بر پرتاب تاس برای پریدن از روی دشمنان، میمون باید قمار کند تا خرس را بگیرد',
    monkeyGamblePost: 'میمون باید ۵ یا ۶ روی تاس ۶ وجهی بیاورد تا خرس را بگیرد وگرنه خودش گرفته می‌شود',

    // Octopus
    octopusMovement: 'اختاپوس یک خانه در هر جهت حرکت می‌کند',
    octopusCapture: 'اختاپوس فقط می‌تواند به صورت متعامد بگیرد',
    octopusCapturePost: 'اختاپوس می‌تواند مهره‌ها را به روش‌های پیچیده بگیرد یا درهم ببافد، پس همیشه گرفتن‌های قرمز و درهم تنیدگی‌های بنفش را بررسی کنید!',
    octopusEntangle: 'اختاپوس می‌تواند مهره‌های دشمن مجاور را درهم ببافد و بی‌حرکت کند، حتی می‌تواند یک خانه حرکت کند و دشمنان را درهم ببافد!',
    octopusEntanglePost: 'مهره‌های درهم تنیده نمی‌توانند حرکت کنند تا زمانی که اختاپوس دور شود یا گرفته شود',
    octopusInk: 'اختاپوس می‌تواند از مرکب برای فرار از موقعیت‌های خطرناک استفاده کند و تا ۳ سایه ایجاد کند',
    octopusInkPost: 'گیج کردن دشمن و امکان بازی‌های طعمه‌گذاری و فراری جالب',

    // Penguin
    penguinMovement: 'پنگوئن در یک خط مستقیم در جهت تعیین شده‌اش می‌لغزد تا زمانی که دیوار یا مهره‌ای حرکتش را مسدود کند',
    penguinMovementPost: 'پس از حرکت، پنگوئن در همان نوبت می‌تواند جهت نهایی خود را نیز تنظیم کند',
    penguinRotate: 'در ابتدای مسابقه پنگوئن رو به پایین است و باید قبل از اینکه بتواند بلغزد بچرخد، همچنین به عنوان خواب شناخته می‌شود',
    penguinRotatePost: 'پنگوئن در هر موقعیتی می‌تواند به جای حرکت چرخش را انتخاب کند',
    penguinBirdType: 'پنگوئن توانایی گرفتن محدودی دارد، مانند درنا، نمی‌تواند مهره‌های بزرگ یا درنده مانند درخت، کرگدن، خرس یا گرگ را بگیرد',
    penguinBirdTypePost: 'پس از گرفتن، پنگوئن می‌تواند برای موقعیت‌یابی استراتژیک به هر جهت بچرخد',

    // Rhino
    rhinoMovement: 'کرگدن فقط دو خانه به جلو حرکت می‌کند',
    rhinoMovementPost: 'نمی‌تواند فقط ۱ خانه حرکت کند',
    rhinoBackStep: 'کرگدن می‌تواند عقب-چپ یا عقب-راست حرکت کند',
    rhinoCharge: 'کرگدن یک بار در هر بازی می‌تواند با استفاده از توانایی یورش یک خانه اضافی به جلو برود',
    rhinoChargePost: 'که منجر به پتانسیل حرکت و گرفتن ویرانگر می‌شود',
    rhinoTrample: 'کرگدن تمام مهره‌های موجود در مسیر حرکت خود را با لگدمال کردن می‌گیرد',
    rhinoTramplePost: 'از جمله مهره بز غش کرده',
    rhinoLane: 'کرگدن می‌تواند با مهره متحد دیگری جای عوض کند و بازی مسیری استراتژیک را امکان‌پذیر کند',
    rhinoLanePost: 'اما فقط اگر هم کرگدن و هم مهره متحد هنوز حرکت نکرده باشند',

    // Snake
    snakeMovement: 'مار می‌تواند ۲ خانه در هر خط مستقیم حرکت کند',
    snakeMovementPost: 'مار دقیقاً ۲ خانه حرکت می‌کند مگر اینکه توسط دیوار یا مهره دوست مسدود شود',
    snakeMoveBlocks: 'وقتی توسط دیوار یا مهره‌ای که نمی‌تواند بگیرد مسدود شود، حرکت مار به ۱ خانه کاهش می‌یابد',
    snakeMoveBlocksPost: 'همچنان می‌تواند دو خانه حرکت کند حتی اگر یک مهره میانی وجود داشته باشد',
    snakeStrike: 'مار می‌تواند ۳ خانه به جلو حمله کند اگر حیوان دشمن وجود داشته باشد',
    snakeStrikePost: 'تا زمانی که هیچ مهره میانی مسیرش را مسدود نکند',
    snakeShedskin: 'یک بار در هر بازی، مار می‌تواند پوست خود را بیندازد و به ردیف اول برگردد اگر خانه خالی باشد',
    snakeShedskinPost: 'این تولد دوباره به مار یک زندگی اضافی در هر بازی می‌دهد',

    // Tree
    treeMovement: 'درخت می‌تواند یک خانه به جلو یا به هر خانه در ردیف خود به طرفین حرکت کند',
    treeMovementPost: 'تا زمانی که مسیرش مسدود نشده باشد',
    treeHouse: 'درخت می‌تواند مهره‌های دیگر را جای دهد و از آن‌ها در برابر دشمنانی که نمی‌توانند از درخت بالا بروند محافظت کند. برخی مهره‌ها می‌توانند بالا بروند مانند خرس، درنا، قورباغه، قارچ، بز، میمون، اختاپوس و مار',
    treeHousePost: 'وقتی مهره‌ای که می‌تواند از درخت بالا برود حمله می‌کند، فقط مهره جای داده شده را می‌گیرد و درخت را محافظت می‌کند',
    treeTrample: 'درخت مانند کرگدن، تمام مهره‌های موجود در یک خانه را هنگام حرکت می‌گیرد',
    treeTramplePost: 'این شامل بز غش کرده می‌شود',
    treePlant: 'درخت یک گیاه است، نه حیوان، بنابراین در برابر چندین اثر ایمن است',
    treePlantPost: 'مانند سم، زامبی شدن، درهم تنیدگی و عفونت ویروسی!',

    // Virus
    virusMovement: 'ویروس فقط می‌تواند به خانه‌های اشغال شده توسط حیوانات که دو خانه دورتر هستند حرکت کند',
    virusMoveBlocks: 'ویروس فقط می‌تواند یک خانه حرکت کند اگر در کنار دیوار باشد',
    virusCaptureHost: 'وقتی ویروس روی (در) هر مهره حیوانی فرود می‌آید، فقط آن را آلوده می‌کند، آن‌ها می‌توانند در حالی که آلوده هستند به بازی عادی ادامه دهند',
    virusCaptureHostPost: 'ویروس فقط وقتی میزبان آلوده را ترک می‌کند مهره را می‌گیرد',
    virusContagion: 'ویروس می‌تواند با آلوده کردن میزبان‌های متعدد در یک نوبت به سرعت گسترش یابد',
    virusContagionPost: 'سرایت به ویروس اجازه می‌دهد در هر نوبت به تعداد دلخواه حرکت قانونی انجام دهد',

    // Wolf
    wolfMovement: 'گرگ می‌تواند به شکل L حرکت کند، مانند اسب در شطرنج',
    wolfMovementPost: 'توسط هیچ مهره دیگری مسدود نمی‌شود',
    wolfLoneWolf: 'گرگ',
    wolfLoneWolfPost: 'گرگ همچنین خود را تنها می‌داند وقتی فقط یک بز غش کرده یا یک متحد ویروس دارد',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 برای کاوش بکشید • برای بزرگ‌نمایی نیشگون بزنید',
    dragToExploreDesktop: '🖱️ برای کاوش بکشید • برای بزرگ‌نمایی اسکرول کنید',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'بازگشت',
    next: 'بعدی',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'جعبه شنی',
    description: 'آزمایش و تمرین',
    mode: 'حالت:',
    modeValue: 'جعبه شنی',
    status: 'وضعیت:',
    statusReady: 'آماده',
    clearBoard: 'پاک کردن صفحه',
  },

  // Multiplayer
  multiplayer: {
    title: 'چند نفره',
    description: 'مسابقه خود را پیدا کنید و رقابت کنید!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'مسابقات جایگاه‌یابی',
    matchProgress: 'پیشرفت مسابقه',
    gamesCompleted: '{games} / ۱۰ بازی تکمیل شده',
    estimatedFinalRating: 'رتبه نهایی تخمینی',
    startingRating: 'رتبه شروع',
    matchesRemaining: '{matches} مسابقه باقی‌مانده',
    findPlacementMatch: 'یافتن مسابقه جایگاه‌یابی',

    // Matchmaking modes
    findMatch: 'یافتن مسابقه',
    competitive: 'رقابتی',
    competitiveDesc: 'یافتن حریفان نزدیک به رتبه شما',
    quick: 'سریع',
    quickDesc: 'یافتن سریع مسابقات رقابتی',
    casual: 'معمولی',
    casualDesc: 'بدون رتبه - برای سرگرمی بازی کنید!',
    placement: 'تعیین رتبه',
    placementDesc: 'برای دریافت رتبه 10 مسابقه را تکمیل کنید',
    startSearch: 'شروع جستجو',

    // Searching
    searching: 'در حال جستجو...',
    mode: 'حالت:',
    inQueue: 'در صف:',
    players: 'بازیکن',
    playersPlural: 'بازیکنان',
    cancelSearch: 'لغو جستجو',

    // Game info
    status: 'وضعیت:',
    ready: 'آماده',
    selectingKing: 'انتخاب شاه',
    placingPieces: 'قرار دادن مهره‌ها',
    playing: 'در حال بازی',
    gameType: 'نوع بازی:',
    opponent: 'حریف:',
    opponentElo: 'ELO حریف:',
    unranked: 'بدون رتبه',

    // Piece placement
    dragPieces: 'مهره‌ها را به صفحه بکشید',
    lightPieces: 'مهره‌های روشن (شما)',
    darkPieces: 'مهره‌های تیره (شما)',

    // Waiting states
    waitingForOpponent: 'در انتظار حریف...',
    waitingForKing: 'در انتظار انتخاب شاه توسط حریف...',

    // Warnings
    invalidPlacement: 'قرارگیری نامعتبر',
    lightTurn: 'نوبت بازیکن روشن است!',
    darkTurn: 'نوبت بازیکن تیره است!',
    onlyLightPieces: 'فقط می‌توانید مهره‌های روشن بگذارید!',
    onlyDarkPieces: 'فقط می‌توانید مهره‌های تیره بگذارید!',
    mustPlaceOnRow: 'مهره‌های {color} باید در ردیف {row} قرار بگیرند!',

    // Chat
    chat: 'چت',
    typeMessage: 'پیام بنویسید...',
    send: 'ارسال',
  },

  // Main Page
  mainPage: {
    title: 'شطرنج حیوانات',
    subtitle: 'بازی برای انسان‌ها',
    playersOnline: 'بازیکنان آنلاین فعلی',
    placement: 'جایگاه‌یابی',
    placementProgress: 'جایگاه‌یابی',
    challengeAI: 'چالش با هوش مصنوعی',
    multiplayer: 'چند نفره',
    sandbox: 'جعبه شنی',
    tutorials: 'آموزش‌ها',
    shop: 'فروشگاه',
    collection: 'مجموعه',
    history: 'تاریخچه',
    analytics: 'تجزیه و تحلیل',
    courses: 'دوره‌ها',
    upgradeAccount: 'ارتقای حساب',
    signIn: 'ورود',
    playAsGuest: 'بازی به عنوان مهمان',
    welcomeBack: 'خوش آمدید! معمولاً به عنوان',

    // Learn the Pieces section
    learnThePieces: 'مهره‌ها را یاد بگیرید',

    // Learn the Rules section
    learnTheRules: 'قوانین را یاد بگیرید',
    premiseTitle: 'فرضیه',
    premiseText: 'زودیاک یک جایگزین شطرنج با شاه پنهان از فهرست ۱۳ مهره است، یک فهرست منحصر به فرد انتخاب کنید و سپس حریف خود را بلوف بزنید تا در صفحه ۵x۸ شکستش دهید',
    selectionTitle: 'انتخاب',
    selectionText: 'برای شروع بازی، مخفیانه شاه خود را انتخاب کنید، سپس ۵ مهره خود را متناوباً با حریف قرار دهید تا یکی از بیش از ۵۰۰ میلیارد حالت اولیه ایجاد شود.',
    objectiveTitle: 'هدف',
    objectiveText: 'یا حریف را بخوانید تا شاه مخفی او را بگیرید یا شاه خود را در سراسر صفحه رقابت دهید تا پیروزی را تضمین کنید!',
    competeTitle: 'رقابت',
    competeText: 'مهارت‌های خود را در نردبان آزمایش کنید، تکنیک‌ها و استراتژی‌های شخصی جدید توسعه دهید، رتبه را بالا ببرید تا با بهترین‌ها روبرو شوید!',
    fullRulesButton: 'برای قوانین رسمی کامل اینجا کلیک کنید',

    // FAQ section
    faqTitle: 'سوالات متداول',
    faqQuestion1: 'ایده پشت شطرنج زودیاک چیست؟',
    faqAnswer1: 'شطرنج زودیاک در ابتدا از کلمات بابی فیشر در مورد الهام او برای ساخت Chess960 الهام گرفت، ما می‌خواستیم ایده مبارزه با حفظ ماشینی را گسترش دهیم و شهود انسانی را در عمق غیرقابل تصور جشن بگیریم!',
    faqQuestion2: 'چرا به جایگزین شطرنج نیاز داریم',
    faqAnswer2: 'نیاز نداریم! زودیاک نمی‌خواهد مردم را از بازی شطرنج منحرف کند! این یک گزینه متفاوت با نقاط قوت و ضعف خاص خود است، امیدواریم با آن سرگرم شوید و به ما کمک کنید این بازی را برای زنده کردن بازی جدید تطبیق دهیم',
    faqQuestion3: 'چگونه در شطرنج زودیاک برنده می‌شوید؟',
    faqAnswer3: 'سه راه برای برد وجود دارد: شاه پنهان حریف را بگیرید، شاه خود را به طرف دیگر صفحه برسانید، یا در مسابقه با کنترل زمان، زمان حریف تمام شود',
    faqQuestion4: 'آیا این یک سوالات متداول است؟',
    faqAnswer4: 'بله، می‌توانید به هر یک از سوالات فهرست شده در سوالات متداول نگاه کنید و اگر جزئیات بیشتری می‌خواهید، می‌توانید روی سوالات کلیک کنید و سپس جزئیات زیر را بخوانید، مانند این جزئیاتی که الان می‌خوانید',
    faqQuestion5: 'یک بازی معمولی چقدر طول می‌کشد؟',
    faqAnswer5: 'هر بازی به شدت متفاوت است! برخی بازی‌ها در ۲ حرکت تمام می‌شوند و برخی ممکن است ۳۰ دقیقه طول بکشند، معمولاً آن‌ها در بازه ۵-۱۵ دقیقه هستند!',
    faqQuestion6: 'اگر هیچ کس نتواند حرکت قانونی انجام دهد چه اتفاقی می‌افتد؟',
    faqAnswer6: 'اگر بازیکنی نتواند هیچ حرکت قانونی انجام دهد (بن‌بست)، بازی با تساوی پایان می‌یابد. بازی همچنین می‌تواند از طریق تکرار (حالت یکسان صفحه ۳ بار) یا با توافق متقابل بین بازیکنان با تساوی پایان یابد!',

    // About section
    aboutButton: 'درباره',
    privacyPolicy: 'سیاست حفظ حریم خصوصی',
    developerInterface: 'رابط توسعه‌دهنده',
  },

  // About Modal
  about: {
    title: 'درباره زودیاک',
    paragraph1: 'زودیاک یک بازی تخته شبیه شطرنج است که عناصر انتخاب مهره از بازی‌هایی مانند LoL و DotA را با مکانیک بلوف از پوکر یا بازی‌های استنتاج اجتماعی ترکیب می‌کند.',
    paragraph2: 'نسخه‌های اولیه بازی در سال ۲۰۱۴ تحت نام Shadow Chess ساخته شد. در سال ۲۰۱۸ بازطراحی شد تا همان چیزی باشد که امروز می‌بینید، شامل فهرستی از مهره‌های سرگرم‌کننده با الگوهای حرکت و توانایی‌های متعادل اما منحصر به فرد.',
    paragraph3: 'چشم‌انداز ما ثبت تمام داده‌های گیم‌پلی کاربر است تا به تکامل بازی ادامه دهیم در تلاش برای تازه نگه‌داشتن گیم‌پلی و تشویق بازی‌های جدید.',
    paragraph4: 'با فضای جستجوی غول‌پیکر زودیاک، اطلاعات پنهان و موقعیت‌های افتتاحیه صفحه، امیدواریم از تسلط هوش مصنوعی جلوگیری کنیم و زودیاک را بازی برای انسان‌ها نگه داریم!',
  },

  // Privacy Policy
  privacy: {
    title: 'سیاست حفظ حریم خصوصی',
    lastUpdated: 'آخرین به‌روزرسانی',

    introduction: {
      title: 'مقدمه',
      p1: 'به Zodiac Chess ("ما"، "خودمان" یا "ما") خوش آمدید. ما متعهد به حفظ حریم خصوصی شما و اطمینان از تجربه بازی ایمن و لذت‌بخش هستیم. این سیاست حفظ حریم خصوصی توضیح می‌دهد که چگونه اطلاعات شما را هنگام استفاده از وب‌سایت و بازی ما جمع‌آوری، استفاده، افشا و محافظت می‌کنیم.',
      p2: 'با استفاده از Zodiac Chess، با جمع‌آوری و استفاده از اطلاعات مطابق با این سیاست موافقت می‌کنید. اگر با سیاست‌ها و رویه‌های ما موافق نیستید، لطفاً از سرویس ما استفاده نکنید.',
      contact: 'با ما تماس بگیرید:',
    },

    infoCollect: {
      title: 'اطلاعاتی که جمع‌آوری می‌کنیم',
      accountInfo: {
        title: '۱. اطلاعات حساب',
        item1: 'آدرس ایمیل: مورد نیاز برای ایجاد حساب و ارتباط',
        item2: 'نام کاربری: نام نمایشی انتخابی شما',
        item3: 'رمز عبور: رمزگذاری شده و به طور ایمن ذخیره می‌شود',
      },
      gameData: {
        title: '۲. داده‌های بازی',
        item1: 'آمار بازی: برد، باخت، رتبه ELO، پیشرفت مسابقه جایگاه‌یابی',
        item2: 'داده‌های گیم‌پلی: انتخاب مهره‌ها، حرکات انجام شده، استراتژی‌های استفاده شده',
        item3: 'تاریخچه مسابقات: سوابق بازی‌های انجام شده، حریفان روبرو شده',
        item4: 'خریدهای درون بازی: اقلام زینتی و وضعیت عضویت ویژه',
      },
      technicalData: {
        title: '۳. داده‌های فنی',
        item1: 'اطلاعات دستگاه: نوع مرورگر، سیستم عامل',
        item2: 'داده‌های استفاده: صفحات بازدید شده، زمان صرف شده، ویژگی‌های استفاده شده',
        item3: 'ذخیره محلی: ترجیحات زبان، تنظیمات رابط کاربری، وضعیت موقت بازی',
      },
    },

    children: {
      title: 'حریم خصوصی کودکان (انطباق با COPPA)',
      p1: 'Zodiac Chess طراحی شده است تا خانواده‌پسند و مناسب برای بازیکنان در همه سنین، از جمله کودکان باشد. ما مراقبت ویژه‌ای برای رعایت قانون حفاظت از حریم خصوصی آنلاین کودکان (COPPA) داریم.',
      p2: 'برای کاربران زیر ۱۳ سال: توصیه می‌کنیم کودکان از حالت بازی مهمان ما استفاده کنند که نیازی به ایجاد حساب یا جمع‌آوری داده ندارد. حساب‌های مهمان به ویژگی‌های چت متنی دسترسی ندارند و اطمینان می‌دهند که کودکان در معرض ارتباط با اینترنت گسترده‌تر نیستند. اگر کودکی حساب ایجاد کند، قبل از جمع‌آوری اطلاعات شخصی به رضایت والدین نیاز داریم.',
      p3: 'ما آگاهانه اطلاعات شخصی از کودکان زیر ۱۳ سال را بدون رضایت تأیید شده والدین جمع‌آوری، استفاده یا به اشتراک نمی‌گذاریم.',
      p4: 'امنیت چت: چت متنی به طور خودکار برای همه حساب‌های مهمان/موقت غیرفعال است. دارندگان حساب استاندارد می‌توانند عملکرد چت را در تنظیمات حساب خود در هر زمان غیرفعال کنند.',
      parentalRights: 'والدین حق دارند:',
      right1: 'بررسی اطلاعات شخصی فرزند خود',
      right2: 'درخواست حذف داده‌های فرزند خود',
      right3: 'امتناع از جمع‌آوری یا استفاده بیشتر از اطلاعات فرزندشان',
      contactUs: 'برای اعمال این حقوق یا اگر فکر می‌کنید فرزند شما اطلاعات شخصی به ما ارائه داده است، لطفاً فوراً با ما تماس بگیرید contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'چگونه از اطلاعات شما استفاده می‌کنیم',
      item1: 'ارائه و بهبود خدمات بازی ما',
      item2: 'مطابقت شما با حریفان مناسب بر اساس سطح مهارت',
      item3: 'ردیابی پیشرفت، آمار و دستاوردهای شما',
      item4: 'پردازش پرداخت‌ها برای عضویت ویژه و اقلام زینتی',
      item5: 'ارسال اعلامیه‌ها و به‌روزرسانی‌های مهم سرویس',
      item6: 'تجزیه و تحلیل داده‌های گیم‌پلی برای بهبود تعادل و ویژگی‌های بازی',
    },

    thirdParty: {
      title: 'سرویس‌های شخص ثالث',
      firebase: {
        title: 'Firebase (گوگل)',
        description: 'ما از Firebase برای احراز هویت، ذخیره‌سازی پایگاه داده و عملکرد چند نفره استفاده می‌کنیم. Firebase ممکن است داده‌های خاصی را همانطور که در سیاست حفظ حریم خصوصی آن‌ها شرح داده شده جمع‌آوری کند.',
      },
      stripe: {
        title: 'استرایپ',
        description: 'ما از Stripe برای پردازش پرداخت‌ها برای عضویت ویژه و خریدهای درون برنامه استفاده می‌کنیم. Stripe تمام اطلاعات کارت پرداخت را مدیریت می‌کند - ما هرگز جزئیات کامل پرداخت شما را نمی‌بینیم یا ذخیره نمی‌کنیم.',
      },
      netlify: {
        title: 'نتلیفای',
        description: 'وب‌سایت ما روی Netlify میزبانی شده است که ممکن است داده‌های استاندارد میزبانی وب مانند آدرس‌های IP و گزارش‌های دسترسی را جمع‌آوری کند.',
      },
      adsense: {
        title: 'گوگل ادسنس (آینده)',
        description: 'ممکن است تبلیغات را از طریق Google AdSense نمایش دهیم. این تبلیغات ممکن است از کوکی‌ها برای شخصی‌سازی استفاده کنند. برای محتوای هدایت شده به کودکان، فقط تبلیغات غیرشخصی را مطابق با COPPA نشان خواهیم داد.',
      },
      viewPolicy: 'سیاست حفظ حریم خصوصی آن‌ها را مشاهده کنید',
    },

    cookies: {
      title: 'کوکی‌ها و ذخیره محلی',
      description: 'ما از ذخیره محلی مرورگر (مشابه کوکی‌ها) برای بهبود تجربه شما استفاده می‌کنیم:',
      item1: 'ترجیح زبان: به یاد سپردن زبان انتخابی شما',
      item2: 'جلسه حساب: شما را وارد سیستم نگه دارید (با Firebase کار می‌کند)',
      item3: 'تنظیمات بازی: به یاد سپردن ترجیحات رابط کاربری و تنظیمات جعبه شنی شما',
      item4: 'کوکی‌های تبلیغاتی: اگر رضایت دهید، سرویس‌های تبلیغاتی شخص ثالث ممکن است از کوکی‌ها برای شخصی‌سازی تبلیغات استفاده کنند',
    },

    security: {
      title: 'امنیت داده',
      p1: 'ما اقدامات امنیتی مناسب برای محافظت از اطلاعات شما اجرا می‌کنیم:',
      item1: 'رمزگذاری رمز عبور: تمام رمزهای عبور با استفاده از روش‌های استاندارد صنعت رمزگذاری می‌شوند',
      item2: 'اتصالات ایمن: رمزگذاری HTTPS برای تمام انتقال داده',
      item3: 'قوانین امنیتی Firebase: کنترل‌های دسترسی سخت‌گیرانه پایگاه داده',
      p2: 'با این حال، هیچ روش انتقال از طریق اینترنت ۱۰۰٪ امن نیست. در حالی که تلاش می‌کنیم از داده‌های شما محافظت کنیم، نمی‌توانیم امنیت مطلق را تضمین کنیم.',
    },

    retention: {
      title: 'نگهداری داده',
      p1: 'ما داده‌های شما را به شرح زیر نگه می‌داریم:',
      item1: 'حساب‌های فعال: داده‌ها در حالی که حساب شما فعال است نگهداری می‌شود',
      item2: 'حساب‌های غیرفعال: اگر حساب شما برای ۱۰ سال غیرفعال باشد، ممکن است داده‌های شما را حذف کنیم',
    },

    rights: {
      title: 'حقوق حریم خصوصی شما',
      description: 'بسته به مکان شما، ممکن است حقوق زیر را داشته باشید:',
      access: {
        title: 'دسترسی:',
        description: 'درخواست کپی از داده‌های شخصی خود',
      },
      correction: {
        title: 'اصلاح:',
        description: 'درخواست اصلاح داده‌های خود',
      },
      deletion: {
        title: 'حذف:',
        description: 'درخواست حذف حساب و داده‌های خود',
      },
      portability: {
        title: 'قابلیت حمل داده:',
        description: 'درخواست داده‌های خود در قالب قابل حمل',
      },
      optOut: {
        title: 'انصراف:',
        description: 'انصراف از ارتباطات بازاریابی',
      },
      contact: 'برای اعمال هر یک از این حقوق، لطفاً با ما تماس بگیرید contact@zodiac-chess.com',
    },

    international: {
      title: 'کاربران بین‌المللی',
      p1: 'Zodiac Chess از نیوزیلند اداره می‌شود. اگر از خارج از نیوزیلند به سرویس ما دسترسی دارید، لطفاً توجه داشته باشید که اطلاعات شما ممکن است به نیوزیلند و کشورهای دیگری که ارائه‌دهندگان سرویس ما در آنجا فعالیت می‌کنند منتقل، ذخیره و پردازش شود.',
      p2: 'با استفاده از سرویس ما، با انتقال اطلاعات خود به کشورهای خارج از کشور محل سکونت خود که ممکن است قوانین حفاظت از داده‌های متفاوتی داشته باشند موافقت می‌کنید.',
    },

    changes: {
      title: 'تغییرات در این سیاست حفظ حریم خصوصی',
      description: 'ممکن است گاهی این سیاست حفظ حریم خصوصی را به‌روزرسانی کنیم. در صورت هرگونه تغییر با ارسال سیاست حفظ حریم خصوصی جدید در این صفحه و به‌روزرسانی تاریخ "آخرین به‌روزرسانی" به شما اطلاع خواهیم داد. تغییرات مهم از طریق ایمیل یا اطلاعیه برجسته در وب‌سایت ما اطلاع‌رسانی خواهد شد.',
    },

    contact: {
      title: 'تماس با ما',
      description: 'اگر سؤال، نگرانی یا درخواستی در مورد این سیاست حفظ حریم خصوصی یا رویه‌های داده ما دارید، لطفاً با ما تماس بگیرید:',
      email: 'ایمیل:',
      company: 'شرکت:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'شرایط خدمات',
    lastUpdated: 'آخرین به‌روزرسانی',
    back: 'بازگشت',
    viewPrivacyPolicy: 'مشاهده سیاست حفظ حریم خصوصی',
    acknowledgment: 'با استفاده از Zodiac Chess، شما تأیید می‌کنید که این شرایط خدمات را خوانده، درک کرده و با پایبندی به آن موافقت می‌کنید.',
    acceptance: {
      title: '۱. پذیرش شرایط',
      p1: 'با دسترسی و استفاده از Zodiac Chess ("سرویس")، شما این شرایط خدمات را می‌پذیرید و موافقت می‌کنید که به آن پایبند باشید. اگر با این شرایط موافق نیستید، لطفاً از سرویس استفاده نکنید.',
      p2: 'ما حق تغییر این شرایط را در هر زمان برای خود محفوظ می‌داریم. ادامه استفاده از سرویس پس از تغییرات به معنای پذیرش شرایط اصلاح شده است.',
    },
    description: {
      title: '۲. توضیحات سرویس',
      p1: 'Zodiac Chess یک بازی تخته استراتژیک آنلاین با مهره‌های حیوانی منحصر به فرد با توانایی‌های ویژه است. سرویس شامل:',
      feature1: 'بازی تک‌نفره در مقابل حریفان هوش مصنوعی',
      feature2: 'جورسازی چند نفره و بازی رقابتی',
      feature3: 'آموزش‌های تعاملی و منابع یادگیری',
      feature4: 'ایجاد حساب و ردیابی پیشرفت',
      feature5: 'ویژگی‌های اشتراک ویژه اختیاری',
      feature6: 'گزینه‌های سفارشی‌سازی ظاهری',
    },
    accounts: {
      title: '۳. حساب‌های کاربری',
      eligibility: {
        title: '۳.۱ واجد شرایط بودن',
        p1: 'برای ایجاد حساب باید حداقل ۱۳ سال سن داشته باشید. کاربران زیر ۱۳ سال می‌توانند با نظارت والدین از حالت بازی مهمان استفاده کنند اما نمی‌توانند حساب ایجاد کنند.',
      },
      responsibilities: {
        title: '۳.۲ امنیت حساب',
        p1: 'شما مسئول موارد زیر هستید:',
        item1: 'حفظ محرمانگی رمز عبور خود',
        item2: 'تمام فعالیت‌هایی که تحت حساب شما انجام می‌شود',
        item3: 'اطلاع‌رسانی فوری به ما در مورد هرگونه استفاده غیرمجاز',
        p2: 'ما مسئول هیچ ضرر یا آسیبی ناشی از دسترسی غیرمجاز به حساب نیستیم.',
      },
      prohibited: {
        title: '۳.۳ فعالیت‌های ممنوع',
        p1: 'شما مجاز نیستید:',
        item1: 'حساب خود را با دیگران به اشتراک بگذارید',
        item2: 'از چندین حساب برای دستکاری رتبه‌بندی استفاده کنید',
        item3: 'از ربات‌ها، اسکریپت‌ها یا ابزارهای خودکار برای بازی استفاده کنید',
        item4: 'بازیکنان دیگر را آزار دهید، مورد سوءاستفاده قرار دهید یا تهدید کنید',
        item5: 'از باگ‌ها یا نقص‌ها برای مزیت ناعادلانه سوءاستفاده کنید',
        item6: 'مهندسی معکوس کنید یا تلاش کنید به کد منبع ما دسترسی پیدا کنید',
        p2: 'نقض این قوانین ممکن است منجر به تعلیق حساب یا مسدودیت دائمی شود.',
      },
    },
    premium: {
      title: '۴. اشتراک‌های ویژه',
      billing: {
        title: '۴.۱ صورتحساب',
        p1: 'اشتراک‌های ویژه از طریق Stripe پردازش می‌شوند. با خرید اشتراک ویژه، شما به ما اجازه می‌دهید که به صورت دوره‌ای روش پرداخت شما را شارژ کنیم تا زمانی که لغو کنید.',
        p2: 'هزینه‌های اشتراک عبارتند از:',
        item1: 'طرح ماهانه: ماهانه در سالگرد تاریخ خرید شما شارژ می‌شود',
        item2: 'طرح سالانه: سالانه در سالگرد تاریخ خرید شما شارژ می‌شود',
        p3: 'قیمت‌ها با اطلاع‌رسانی ۳۰ روزه به مشترکین فعال قابل تغییر هستند.',
      },
      cancellation: {
        title: '۴.۲ لغو',
        p1: 'می‌توانید اشتراک خود را در هر زمان از طریق تنظیمات حساب یا با تماس با پشتیبانی لغو کنید. لغو در پایان دوره صورتحساب فعلی شما اعمال می‌شود.',
        p2: 'شما ویژگی‌های ویژه را تا پایان دوره پرداخت شده حفظ خواهید کرد، حتی پس از لغو.',
      },
      refunds: {
        title: '۴.۳ بازپرداخت',
        p1: 'اشتراک‌های ماهانه: بازپرداخت برای ماه‌های ناقص وجود ندارد. در هر زمان لغو کنید تا شارژهای آینده متوقف شود.',
        p2: 'اشتراک‌های سالانه: بازپرداخت کامل اگر در عرض ۷ روز از خرید درخواست شود. پس از ۷ روز، بازپرداخت به صلاحدید ما است.',
        p3: 'خریدهای ظاهری: معمولاً غیرقابل بازپرداخت. برای شرایط استثنایی با پشتیبانی تماس بگیرید.',
      },
    },
    acceptable: {
      title: '۵. سیاست استفاده قابل قبول',
      p1: 'شما موافقت می‌کنید که از Zodiac Chess به شیوه‌ای محترمانه و قانونی استفاده کنید. رفتار ممنوع شامل:',
      item1: 'تقلب، هک یا سوءاستفاده از مکانیک‌های بازی',
      item2: 'آزار و اذیت، سخنان نفرت‌انگیز یا زبان تبعیض‌آمیز',
      item3: 'ارسال هرزنامه، تبلیغات یا درخواست',
      item4: 'به اشتراک‌گذاری محتوای نامناسب (اگر چت یا محتوای تولید شده توسط کاربر فعال باشد)',
      item5: 'جعل هویت کاربران دیگر یا اعضای کارکنان',
      item6: 'تلاش برای اختلال یا آسیب رساندن به سرویس',
      p2: 'ما حق بررسی تخلفات و اقدام مناسب، از جمله فسخ حساب و گزارش به مقامات در صورت لزوم را برای خود محفوظ می‌داریم.',
    },
    intellectual: {
      title: '۶. حقوق مالکیت معنوی',
      ownership: {
        title: '۶.۱ محتوای ما',
        p1: 'تمام محتوای بازی، از جمله اما نه محدود به مکانیک‌های بازی، آثار هنری، انیمیشن‌ها، جلوه‌های صوتی، کد و طراحی، متعلق به Animal Chess Limited یا مجوزدهندگان ما است.',
        p2: 'به شما مجوز محدود، غیرانحصاری و غیرقابل انتقال برای استفاده از سرویس فقط برای اهداف سرگرمی شخصی اعطا می‌شود.',
      },
      userContent: {
        title: '۶.۲ محتوای کاربر',
        p1: 'با ارسال محتوا (مانند پیام‌های چت، نام‌های کاربری یا اطلاعات پروفایل)، شما به ما مجوز جهانی و بدون حق امتیاز برای استفاده، نمایش و توزیع آن محتوا در ارتباط با سرویس اعطا می‌کنید.',
        p2: 'شما تأیید می‌کنید که مالک هستید یا حقوق لازم برای هر محتوایی که ارسال می‌کنید را دارید.',
      },
    },
    disclaimers: {
      title: '۷. سلب مسئولیت و محدودیت‌های مسئولیت',
      p1: 'سرویس «همان‌گونه که هست» بدون هیچ‌گونه ضمانت صریح یا ضمنی ارائه می‌شود.',
      p2: 'ما تضمین نمی‌کنیم که:',
      item1: 'سرویس بدون وقفه یا بدون خطا باشد',
      item2: 'نقص‌ها اصلاح شوند',
      item3: 'سرویس عاری از ویروس‌ها یا اجزای مضر باشد',
      item4: 'نتایج استفاده از سرویس انتظارات شما را برآورده کند',
      p3: 'تا حداکثر حد مجاز قانون، ما مسئول موارد زیر نیستیم:',
      item5: 'هرگونه خسارت غیرمستقیم، اتفاقی یا تبعی',
      item6: 'از دست دادن سود، داده‌ها یا حسن نیت',
      item7: 'وقفه‌های سرویس یا از دست رفتن داده‌ها',
      item8: 'خسارات بیش از مبلغی که در ۱۲ ماه گذشته به ما پرداخت کرده‌اید',
    },
    privacy: {
      title: '۸. حریم خصوصی',
      p1: 'استفاده شما از سرویس همچنین توسط سیاست حفظ حریم خصوصی ما اداره می‌شود که توضیح می‌دهد چگونه اطلاعات شخصی شما را جمع‌آوری، استفاده و محافظت می‌کنیم.',
      p2: 'با استفاده از سرویس، شما با رویه‌های داده ما همانطور که در سیاست حفظ حریم خصوصی توضیح داده شده موافقت می‌کنید.',
    },
    changes: {
      title: '۹. تغییرات در شرایط',
      p1: 'ما حق تغییر این شرایط خدمات را در هر زمان برای خود محفوظ می‌داریم. ما تغییرات مهم را از طریق موارد زیر به کاربران اطلاع خواهیم داد:',
      item1: 'اطلاع‌رسانی ایمیلی به کاربران ثبت‌نام شده',
      item2: 'اعلان برجسته در وب‌سایت',
      item3: 'به‌روزرسانی تاریخ "آخرین به‌روزرسانی" در بالای این صفحه',
      p2: 'ادامه استفاده شما از سرویس پس از تغییرات به معنای پذیرش شرایط اصلاح شده است.',
    },
    governing: {
      title: '۱۰. قانون حاکم',
      p1: 'این شرایط خدمات توسط قوانین نیوزیلند اداره می‌شود، بدون توجه به اصول تعارض قوانین.',
      p2: 'هرگونه اختلاف ناشی از این شرایط یا استفاده شما از سرویس در دادگاه‌های نیوزیلند حل و فصل خواهد شد.',
    },
    contact: {
      title: '۱۱. اطلاعات تماس',
      p1: 'برای سؤالات، نگرانی‌ها یا پشتیبانی در مورد این شرایط خدمات:',
      email: 'ایمیل:',
      company: 'شرکت:',
      address: 'آدرس:',
    },
    severability: {
      title: '۱۲. تفکیک‌پذیری',
      p1: 'اگر هر بخشی از این شرایط غیرقابل اجرا یا نامعتبر شناخته شود، آن بخش تا حد لازم محدود یا حذف خواهد شد و بخش‌های باقی‌مانده به طور کامل معتبر و لازم‌الاجرا باقی خواهند ماند.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'سیاست کوکی',
    lastUpdated: 'آخرین به‌روزرسانی',
    browserInstructions: {
      chrome: 'تنظیمات ← حریم خصوصی و امنیت ← کوکی‌ها',
      firefox: 'تنظیمات ← حریم خصوصی و امنیت ← کوکی‌ها و داده‌های سایت',
      safari: 'ترجیحات ← حریم خصوصی ← کوکی‌ها و داده‌های وب‌سایت',
      edge: 'تنظیمات ← حریم خصوصی، جستجو و خدمات ← کوکی‌ها',
    },
    cookieTable: {
      name: 'نام کوکی',
      purpose: 'هدف',
      duration: 'مدت',
      type: 'نوع',
    },
    relatedPolicies: {
      title: 'سیاست‌های مرتبط',
      description: 'برای اطلاعات بیشتر در مورد نحوه مدیریت داده‌های شما، لطفاً مراجعه کنید به:',
      privacy: 'سیاست حریم خصوصی',
      terms: 'شرایط خدمات',
    },

    introduction: {
      title: 'مقدمه',
      p1: 'این سیاست کوکی توضیح می‌دهد که چگونه Zodiac Chess ("ما") از کوکی‌ها و فناوری‌های مشابه هنگام بازدید شما از وب‌سایت ما استفاده می‌کند.',
      p2: 'با استفاده از وب‌سایت ما، شما با استفاده ما از کوکی‌ها مطابق با این سیاست موافقت می‌کنید. اگر موافق نیستید، لطفاً کوکی‌ها را در تنظیمات مرورگر خود غیرفعال کنید یا از وب‌سایت ما استفاده نکنید.',
    },
    what: {
      title: 'کوکی‌ها چیست؟',
      p1: 'کوکی‌ها فایل‌های متنی کوچکی هستند که هنگام بازدید از یک وب‌سایت روی دستگاه شما (رایانه، گوشی هوشمند، تبلت) قرار می‌گیرند. آن‌ها به طور گسترده برای کارکرد کارآمد وب‌سایت‌ها و ارائه اطلاعات به صاحبان وب‌سایت استفاده می‌شوند.',
      p2: 'کوکی‌ها اهداف مختلفی را دنبال می‌کنند، از جمله به خاطر سپردن ترجیحات شما، تحلیل استفاده از سایت و فعال‌سازی ویژگی‌های خاص.',
    },
    types: {
      title: 'انواع کوکی‌هایی که استفاده می‌کنیم',
      necessary: {
        title: '۱. کوکی‌های ضروری',
        description: 'این کوکی‌ها برای عملکرد صحیح وب‌سایت ضروری هستند. بدون این کوکی‌ها، خدماتی که درخواست کرده‌اید قابل ارائه نیست.',
        examples: 'مثال‌ها:',
        item1: 'کوکی‌های احراز هویت - شما را در حساب کاربری‌تان وارد نگه می‌دارند',
        item2: 'کوکی‌های امنیتی - در برابر فعالیت‌های تقلبی محافظت می‌کنند',
        item3: 'کوکی‌های جلسه - وضعیت بازی شما را در طول یک جلسه حفظ می‌کنند',
        item4: 'ترجیحات رضایت کوکی - انتخاب‌های کوکی شما را به خاطر می‌سپارند',
      },
      analytics: {
        title: '۲. کوکی‌های تحلیلی',
        description: 'این کوکی‌ها با جمع‌آوری اطلاعات ناشناس در مورد بازدید صفحات، زمان صرف شده و ویژگی‌های استفاده شده، به ما کمک می‌کنند تا بفهمیم بازدیدکنندگان چگونه با وب‌سایت ما تعامل دارند.',
        provider: 'ارائه‌دهنده: Firebase Analytics (Google)',
        purpose: 'هدف:',
        item1: 'اندازه‌گیری ترافیک وب‌سایت و تعامل کاربران',
        item2: 'شناسایی ویژگی‌ها و صفحات محبوب',
        item3: 'درک جمعیت‌شناسی کاربران (محدوده سنی، موقعیت عمومی)',
        item4: 'بهبود عملکرد وب‌سایت و تجربه کاربری',
      },
      advertising: {
        title: '۳. کوکی‌های تبلیغاتی',
        description: 'این کوکی‌ها برای نمایش تبلیغات مرتبط با شما استفاده می‌شوند. همچنین تعداد دفعاتی که یک تبلیغ را می‌بینید محدود می‌کنند و به اندازه‌گیری اثربخشی کمپین‌های تبلیغاتی کمک می‌کنند.',
        provider: 'ارائه‌دهنده: Google AdSense',
        purpose: 'هدف:',
        item1: 'نمایش تبلیغات شخصی‌سازی شده بر اساس علایق شما',
        item2: 'اندازه‌گیری عملکرد تبلیغات و تعامل',
        item3: 'جلوگیری از نمایش مکرر یک تبلیغ',
        note: 'توجه: مشترکان ویژه هرگز تبلیغات نمی‌بینند، صرف‌نظر از تنظیمات کوکی.',
      },
    },
    firstThird: {
      title: 'کوکی‌های شخص اول در مقابل شخص ثالث',
      firstParty: {
        title: 'کوکی‌های شخص اول',
        description: 'این‌ها کوکی‌هایی هستند که مستقیماً توسط Zodiac Chess تنظیم می‌شوند. ما از آن‌ها برای عملکرد اساسی سایت، احراز هویت و به خاطر سپردن ترجیحات شما استفاده می‌کنیم.',
      },
      thirdParty: {
        title: 'کوکی‌های شخص ثالث',
        description: 'این‌ها کوکی‌هایی هستند که توسط خدمات خارجی که استفاده می‌کنیم، مانند Google Analytics و Google AdSense تنظیم می‌شوند. کوکی‌های شخص ثالث تابع سیاست‌های حریم خصوصی آن ارائه‌دهندگان هستند.',
      },
    },
    specific: {
      title: 'کوکی‌های خاصی که استفاده می‌کنیم',
      tableHeader: 'در زیر لیست دقیقی از کوکی‌های استفاده شده در وب‌سایت ما آمده است:',
    },
    control: {
      title: 'نحوه کنترل کوکی‌ها',
      consent: {
        title: '۱. بنر رضایت کوکی',
        description: 'هنگامی که برای اولین بار از وب‌سایت ما بازدید می‌کنید، یک بنر رضایت کوکی خواهید دید. شما می‌توانید:',
        item1: 'پذیرش همه - اجازه همه کوکی‌ها (ضروری، تحلیلی و تبلیغاتی)',
        item2: 'رد اختیاری - فقط اجازه کوکی‌های ضروری (بدون تحلیل یا تبلیغات)',
        item3: 'سفارشی‌سازی - انتخاب دقیق انواع کوکی‌هایی که می‌خواهید اجازه دهید',
      },
      browser: {
        title: '۲. تنظیمات مرورگر',
        description: 'اکثر مرورگرهای وب به شما اجازه می‌دهند کوکی‌ها را از طریق تنظیمات خود کنترل کنید. شما می‌توانید:',
        item1: 'مسدود کردن همه کوکی‌ها',
        item2: 'پذیرش فقط کوکی‌های شخص اول',
        item3: 'حذف کوکی‌ها پس از هر جلسه مرور',
        item4: 'مشاهده و حذف کوکی‌های فردی',
        links: 'در اینجا لینک‌هایی برای مدیریت کوکی در مرورگرهای محبوب آمده است:',
      },
      optOut: {
        title: '۳. ابزارهای انصراف',
        description: 'به طور خاص برای کوکی‌های تبلیغاتی، می‌توانید از تبلیغات شخصی‌سازی شده انصراف دهید:',
        googleLink: 'تنظیمات تبلیغات Google',
        googleDesc: ' - مدیریت تبلیغات شخصی‌سازی شده Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - انصراف از تبلیغات مبتنی بر علاقه',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - ابزار انصراف مخصوص اتحادیه اروپا',
      },
    },
    impact: {
      title: 'تأثیر غیرفعال کردن کوکی‌ها',
      p1: 'اگر کوکی‌ها را غیرفعال یا رد کنید، لطفاً توجه داشته باشید که:',
      item1: 'برخی بخش‌های وب‌سایت ممکن است به درستی کار نکنند',
      item2: 'ممکن است نیاز باشد در هر بازدید ترجیحات خود را دوباره وارد کنید',
      item3: 'ممکن است از حساب کاربری خود خارج شوید',
      item4: 'کوکی‌های ضروری برای کار سایت لازم هستند - غیرفعال کردن آن‌ها مانع استفاده شما از ویژگی‌های اصلی می‌شود',
    },
    updates: {
      title: 'به‌روزرسانی‌های این سیاست کوکی',
      p1: 'ما ممکن است این سیاست کوکی را هر از گاهی برای انعکاس تغییرات در رویه‌های ما یا به دلایل قانونی، نظارتی یا عملیاتی به‌روزرسانی کنیم.',
      p2: 'ما با به‌روزرسانی تاریخ "آخرین به‌روزرسانی" در بالای این صفحه، تغییرات مهم را به شما اطلاع خواهیم داد. لطفاً این سیاست را به صورت دوره‌ای بررسی کنید.',
    },
    contact: {
      title: 'تماس با ما',
      p1: 'اگر سؤالی در مورد استفاده ما از کوکی‌ها یا این سیاست کوکی دارید، لطفاً با ما تماس بگیرید:',
      email: 'ایمیل:',
      company: 'شرکت:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'پنگوئن',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'خرس',
    Crane: 'درنا',
    Frog: 'قورباغه',
    Fungi: 'قارچ',
    Goat: 'بز',
    Monkey: 'میمون',
    Octopus: 'اختاپوس',
    Penguin: 'پنگوئن',
    Rhino: 'کرگدن',
    Snake: 'مار',
    Tree: 'درخت',
    Virus: 'ویروس',
    Wolf: 'گرگ',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
